import { useDangerSignStore } from '../stores/dangerSign.store';

export function onDangerSignStop(handler: () => unknown): void {
  useDangerSignStore().$onAction(({ name, after }) => {
    if (name === 'requestStop') after(() => { handler(); });
  });
}
